import type { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PreviewIframe } from '../../components/PreviewIframe';

const GLOBAL_SECTION_TYPES = new Set(['header', 'footer']);

const FullScreenPreviewPage = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const pageId = searchParams.get('pageId') ?? undefined;
  const sectionId = searchParams.get('sectionId') ?? undefined;
  const sectionType = searchParams.get('sectionType') ?? undefined;

  if (!pageId && !sectionId) {
    return (
      <div className="vtwo:h-screen vtwo:w-screen vtwo:flex vtwo:items-center vtwo:justify-center vtwo:text-gray-400">
        Preview not available
      </div>
    );
  }

  // Global sections (header/footer) render standalone; page sections render
  // the full page and scroll to the edited section.
  const isGlobalSection = sectionType && GLOBAL_SECTION_TYPES.has(sectionType);

  return (
    <div className="vtwo:h-screen vtwo:w-screen">
      <PreviewIframe
        pageId={pageId}
        sectionId={isGlobalSection ? sectionId : undefined}
        sectionType={isGlobalSection ? sectionType : undefined}
        scrollToSectionId={!isGlobalSection ? sectionId : undefined}
        scaled={false}
      />
    </div>
  );
};

export default FullScreenPreviewPage;
